<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <package-category-editor
        v-model="form"
        :icon-url="iconUrl"
        :disabled="$isCallCenter"
      ></package-category-editor>
      <div v-if="!$isCallCenter" class="text-end">
        <sc-button
          :disabled="isSaving"
          variant="primary"
          @click="handleClickSave"
        >บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { toCamelCaseObject } from '@/lib/util';
import PackageCategoryEditor from "../components/PackageCategoryEditor";
import iconPreviewMixin from "../mixins/iconPreviewMixin";
import categorySaveMixin from "../mixins/categorySaveMixin";
import { buildCategoryParams } from "../models/categoryParams";

export default {
  components: {
    PageWrapper,
    ScButton,
    PackageCategoryEditor
  },
  mixins: [iconPreviewMixin, categorySaveMixin],
  data() {
    const title = "รายละเอียด Category";
    const form = {
      name: "",
      packages: [],
      iconFile: null
    };

    return {
      title,
      form,
      confirmBeforeSave: true
    };
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      try {
        /* eslint-disable camelcase -- API response */
        const {
          name,
          icon_url,
          packages
        } = await this.fetchData();

        this.form = {
          ...this.form,
          name,
          packages: packages ? toCamelCaseObject(packages) : []
        }

        this.iconUrl = icon_url;
        /* eslint-enable camelcase */
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    async fetchData() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.ruejaiClub.categories.get(
        id
      );

      return response.data.result;
    },
    async save() {
      const { id } = this.$route.params;
      const params = await buildCategoryParams(this.form, this.iconUrl);

      const response = await baanRueJaiClient.admin.ruejaiClub.categories.put(
        id,
        params
      );

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>
